import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "api/baseurl";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
// For your custom button component
import MDButton from "components/MDButton";
// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Box,
  Grid,
  Card,
  Typography,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { keyframes } from "@mui/system";
import { Button } from "@mui/material";
import AddDocuments from "./Addocuments";
import AddStudyDocuments from "./AddstudyDocuments";
import defaultprofileimage from "../images/defaultprofile.jpg";

function ViewCareCoordinator() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [coordinator, setCoordinator] = useState(null);
  const [tab, setTab] = useState(0);
    const [selectedId, setSelectedId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [opencertificateModal, setOpenCertificateModal] = useState(false);

  const fetchCoordinator = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/carecoordinator/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setCoordinator(decrypted ||[]);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoordinator();
  }, [id]);

  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            animation: `${spinAnimation} 1.5s linear infinite`,
          }}
        >
          {dotPositions.map((pos, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                  backgroundColor:"#2e7faeff",
                position: "absolute",
                ...pos,
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }
 const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };
    const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/carecoordinatordocuments/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Care Coordinator Documents deleted successfully!");
    
          setDeleteModal(false); 
          fetchCoordinator();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Care Coordinator Documents.");
      } finally {
        setLoading(false);
      }
    };
const HandleCertificateModal = (id) => {
  setSelectedId(id);
  setOpenCertificateModal(true);
};
const handleClosecerrificateModal = () => {
  setOpenCertificateModal(false);
  setSelectedId(null);
};
  return (
    <DashboardLayout>
      <DashboardNavbar />
    <Card sx={{ p: 3, mt: 3 }}>
  {coordinator ? (
    <Grid container spacing={3}>
      {/* Left: Profile Image */}
      <Grid item xs={12} md={3} textAlign="center">
        <img
          src={coordinator.image ? `data:image/jpeg;base64,${coordinator.image}` : defaultprofileimage}
          alt={coordinator.imageMeta || "Profile"}
          style={{ width: 150, height: 150, borderRadius: "50%" }}
        />
      </Grid>

      {/* Middle: Basic Info */}
      <Grid item xs={12} md={5}>
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
          {coordinator.firstname} {coordinator.lastname}
        </Typography>
<Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Email:</strong> {coordinator.username}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Phone Number:</strong> {coordinator.phonecountrycode} {coordinator.phoneNumber}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>NUID:</strong> {coordinator.nuid}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>NUID Status:</strong> {coordinator.nuidstatus}
        </Typography>
       <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
  <strong>Address:</strong>{" "}
  {[
    coordinator.location.address,
    coordinator.location.city,
    coordinator.location.state,
    coordinator.location.country,
    coordinator.location.pin,
  ]
    .filter(Boolean) 
    .join(", ")}
</Typography>
       
      </Grid>

      {/* Right: More Info */}
      <Grid item xs={12} md={4} sx={{ mt: 4.2 }}>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Age:</strong> {coordinator.age}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Marital Status:</strong> {coordinator.martialStatus}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>DOB:</strong> {coordinator.dob}
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          <strong>Gender:</strong> {coordinator.gender}
        </Typography>
         <Typography sx={{ fontSize: "14px" }}>
          <strong>Certification Valid Till:</strong>{" "}
          {coordinator.certificationvalidtill}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <Typography
      sx={{
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        color: "gray",
        my: 2,
      }}
    >
      No Data Available
    </Typography>
  )}

        {/* Tabs Section */}
        <Box sx={{ mt: 4 }}>
        <Tabs
  value={tab}
  onChange={(e, newVal) => setTab(newVal)}
  variant="scrollable"
  scrollButtons="auto"
  TabIndicatorProps={{
    style: {
      backgroundColor: "#1976d2", // elegant blue underline
      height: "3px",
      borderRadius: "2px",
    },
  }}
  sx={{
    backgroundColor: "#fff", // clean white bg
    borderBottom: "1px solid #e0e0e0",
    "& .MuiTab-root": {
      fontWeight: 500,
      fontSize: "16px",
      textTransform: "none",
      color: "#666",
      minHeight: "48px",
      padding: "10px 20px",
      transition: "all 0.3s ease",
    },
    "& .Mui-selected": {
      color: "#1976d2", // professional blue
      fontWeight: 600,
    },
    "& .MuiTab-root:hover": {
      color: "#1976d2",
      backgroundColor: "rgba(25, 118, 210, 0.08)", // light hover
      borderRadius: "6px 6px 0 0",
    },
  }}
>
  <Tab label="Demographic Certificate" />
  <Tab label="Qualification Certificate" />
</Tabs>

<Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
  <Button
    variant="outlined"
    sx={{
                         textTransform: "none",
                         color: "#000",
                         borderColor: "#000",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#000",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}
    onClick={() => HandleCertificateModal(coordinator?.id)}
  >
    + Add Documents
  </Button>
</Box>



       {tab === 0 && (
  <Box sx={{ mt: 2 }}>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#2e7faeff" }}>
          {["Document Name", "Date of Upload", "Action"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                fontWeight: "bold",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "195px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
        {coordinator?.documents?.filter(doc => doc.documentname !== "Study Certificate").length > 0 ? (
          coordinator.documents
            .filter(doc => doc.documentname !== "Study Certificate")
            .map((doc, idx) => (
              <TableRow key={idx}>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.documentname}
                </TableCell>
                {/* <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.documenttype}
                </TableCell> */}
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.dateofupload}
                </TableCell>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>

                   <IconButton
                                     color="default"
                                     
                                     onClick={(event) => {
                                      event.stopPropagation();
                                      handleOpenDeleteModal(doc.id);
                                    }}                 >
                                     <DeleteIcon />
                                   </IconButton>
                  {doc.image ? (
                  <Tooltip title="View Document">
  <IconButton
    sx={{
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.05)",
      },
    }}
    onClick={() => {
      // Validate document data
      if (!doc?.image) {
        alert('No document data available to preview');
        return;
      }

      try {
        // Detect file type from base64 signature since documenttype is null
        const base64Start = doc.image.substring(0, 50);
        
        // PDF starts with "JVBERi0x" (base64 of "%PDF")
        const isPDF = base64Start.startsWith('JVBERi0x') || 
                      doc.documenttype === "application/pdf" || 
                      doc.documenttype === "pdf" ||
                      doc.documentname?.toLowerCase().endsWith('.pdf');
        
        // PNG starts with "iVBORw0KGgo"
        const isPNG = base64Start.startsWith('iVBORw0KGgo');
        
        // JPEG starts with "/9j/"
        const isJPEG = base64Start.startsWith('/9j/');
        
        console.log('Detected types - PDF:', isPDF, 'PNG:', isPNG, 'JPEG:', isJPEG);

        if (isPDF) {
          // PDF handling with blob
          const binaryString = atob(doc.image);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([bytes], { type: 'application/pdf' });
          console.log('PDF Blob size:', blob.size, 'bytes');
          
          const fileURL = URL.createObjectURL(blob);
          const pdfWindow = window.open(fileURL, '_blank');
          
          if (!pdfWindow) {
            alert('Popups are blocked. Please enable popups for this site.');
          }
          
          setTimeout(() => URL.revokeObjectURL(fileURL), 120000);
        } else {
          // Image handling - auto-detect MIME type
          let mimeType;
          if (isPNG) {
            mimeType = 'image/png';
          } else if (isJPEG) {
            mimeType = 'image/jpeg';
          } else {
            // Default to png if unknown
            mimeType = 'image/png';
          }
          
          console.log('Using MIME type:', mimeType);
          
          const fileURL = `data:${mimeType};base64,${doc.image}`;
          
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.document.write(`
              <!DOCTYPE html>
              <html>
                <head>
                  <title>Image Preview - ${doc.documentname || 'Document'}</title>
                  <style>
                    body { 
                      margin: 0; 
                      display: flex; 
                      justify-content: center; 
                      align-items: center; 
                      min-height: 100vh; 
                      background: #2c3e50;
                    }
                    img { 
                      max-width: 95%; 
                      max-height: 95vh; 
                      box-shadow: 0 4px 20px rgba(0,0,0,0.5);
                      border-radius: 4px;
                    }
                    .error {
                      color: white;
                      text-align: center;
                      font-family: Arial, sans-serif;
                      padding: 20px;
                    }
                  </style>
                </head>
                <body>
                  <img 
                    src="${fileURL}" 
                    alt="${doc.documentname || 'Document'}"
                    onload="console.log('Image loaded successfully')"
                    onerror="this.style.display='none'; document.body.innerHTML='<div class=error><h2>Failed to load image</h2><p>Please try downloading the file instead.</p></div>'"
                  />
                </body>
              </html>
            `);
            newWindow.document.close();
            newWindow.focus();
          } else {
            alert('Popups are blocked. Please enable popups for this site.');
          }
        }
      } catch (error) {
        console.error('Error opening document:', error);
        alert('Error opening document: ' + error.message);
      }
    }}
  >
    <VisibilityIcon />
  </IconButton>
</Tooltip>
                 ) : (
                   "—"
                 )}
                </TableCell>
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={4}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
                  </TableHead>

    </Table>
  </Box>
)}

{tab === 1 && (
  <Box sx={{ mt: 2 }}>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#2e7faeff" }}>
          {["Document Name", "Date of Upload", "Action"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                fontWeight: "bold",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "195px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
        {coordinator?.documents?.filter(doc => doc.documentname === "Study Certificate").length > 0 ? (
          coordinator.documents
            .filter(doc => doc.documentname === "Study Certificate")
            .map((doc, idx) => (
              <TableRow key={idx}>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.documentname}
                </TableCell>
                {/* <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.documenttype}
                </TableCell> */}
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.dateofupload}
                </TableCell>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                   <IconButton
                                     color="default"
                                     
                                     onClick={(event) => {
                                      event.stopPropagation();
                                      handleOpenDeleteModal(doc.id);
                                    }}                 >
                                     <DeleteIcon />
                                   </IconButton>
                 {doc.image ? (
                  <Tooltip title="View Document">
                    <IconButton
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.05)", // subtle hover effect
                        },
                      }}
                      onClick={() => {
                        const fileURL = `data:image/${doc.documenttype};base64,${doc.image}`;
                        const newWindow = window.open();
                        newWindow.document.write(
                          `<iframe src="${fileURL}" width="100%" height="100%" style="border:none;"></iframe>`
                        );
                      }}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  "—"
                )}
                </TableCell>
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={4}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
            </TableHead>

    </Table>
  </Box>
)}

        </Box>
      </Card>
<Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                <Typography variant="h6" gutterBottom>Are you sure you want to delete this Document</Typography>
                <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
              </Card>
            </Modal>
{opencertificateModal && tab === 0 && (
  <AddDocuments
    isOpen={opencertificateModal}
    onRequestClose={handleClosecerrificateModal}
    id={selectedId}
    fetchCoordinator = { fetchCoordinator }
  />
)}
{opencertificateModal && tab === 1 && (
  <AddStudyDocuments
    isOpen={opencertificateModal}
    onRequestClose={handleClosecerrificateModal}
    id={selectedId}
    fetchCoordinator = { fetchCoordinator }
  />
)}
    </DashboardLayout>
  );
}

export default ViewCareCoordinator;
